import { useState, useEffect } from 'react'
import { useAdmin } from '../context/AdminContext'
import { createAdminApi, CharacterListItem } from '../services/adminApi'
import styles from './CharactersPage.module.css'

export default function CharactersPage() {
  const { apiKey } = useAdmin()

  const [characters, setCharacters] = useState<CharacterListItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const api = createAdminApi(() => apiKey)
    setLoading(true)
    setError('')
    api.getCharacters()
      .then(setCharacters)
      .catch(e => setError(e instanceof Error ? e.message : String(e)))
      .finally(() => setLoading(false))
  }, [apiKey])

  function formatDate(iso: string) {
    return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1>Characters</h1>
        <div className={styles.headerStats}>
          {!loading && (
            <span className={styles.statPill}>{characters.length} in DB</span>
          )}
        </div>
      </header>

      {error && <div className={styles.error}>{error}</div>}

      <div className={styles.content}>
        {loading ? (
          <p className={styles.empty}>Loading…</p>
        ) : characters.length === 0 ? (
          <p className={styles.empty}>No characters found.</p>
        ) : (
          <div className={styles.grid}>
            {characters.map(char => (
              <div
                key={char.id}
                className={styles.card}
                onClick={() => { window.location.hash = '#characters/' + char.id }}
                role="button"
                tabIndex={0}
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') window.location.hash = '#characters/' + char.id }}
              >
                <div className={styles.cardHeader}>
                  <span className={styles.cardTitle}>{char.name}</span>
                  {char.version > 1 && (
                    <span className={styles.versionBadge}>v{char.version}</span>
                  )}
                </div>

                <span className={styles.characterId}>{char.id}</span>

                <span className={styles.storyCountPill}>
                  {char.storyCount} {char.storyCount === 1 ? 'story' : 'stories'}
                </span>

                <div className={styles.cardFooter}>
                  <span className={styles.updatedAt}>Updated {formatDate(char.updatedAt)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
